import { OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../';
//import { EmbedVideoService } from 'ngx-embed-video';
import { ErrorHandlerService } from '../../services/index';
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(loginService, errorHandlerService, router) {
        this.loginService = loginService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.model = { newPassword: "", confirmNewPassword: "", resetPasswordLink: "", emailId: "" };
        this.emailId = "";
        this.resetPasswordLink = "";
        this._closePopup = new EventEmitter();
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.showErrorPopupWidthInPercentage = "30%";
        this.isValidationError = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isSignUp = false;
        this.barLabel = "Password strength:";
        this.showForm = true;
        this.Msg = "Password Changed Sucessfully.";
        this.title = "Reset Password";
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
        console.log(this.resetPasswordLink, this.emailId);
        this.model.resetPasswordLink = this.resetPasswordLink;
        this.model.emailId = this.emailId;
    };
    ResetPasswordComponent.prototype.clickLogin = function () {
        this.closeErrorPopup();
        this.closePopup();
        setTimeout(function () {
            $(".headerLoginButton").trigger("click");
        }, 1000);
    };
    ResetPasswordComponent.prototype.resetPassword = function () {
        var _this = this;
        console.log('pass', this.model);
        if (this.model.newPassword == this.model.confirmNewPassword) {
            this.showSpinner = true;
            this.loginService.resetPassword(this.model)
                .subscribe(function (data) {
                console.log('resest', data);
                _this.showSpinner = false;
                _this.showForm = false;
                _this.Msg = "Password Changed Sucessfully.";
                _this.title = "Success!!";
            }, function (error) {
                _this.handleError(error);
                _this.showSpinner = false;
            });
        }
    };
    ResetPasswordComponent.prototype.createInfoAlert = function (alert) {
        this.showErrorMessageTitle = "Success!!";
        this.showErrorMessages.push(alert);
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = true;
        this.isSignUp = true;
    };
    ResetPasswordComponent.prototype.handleError = function (error) {
        var _this = this;
        this.showErrorMessages = [];
        this.isValidationError = true;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        this.showSpinner = false;
        this.showOnlyOverlay = true;
        if (error._body) {
            var errorJson = JSON.parse(error._body);
            if (errorJson.Uvsity_Errors) {
                console.log("Uvsity Exception");
                errorJson.Uvsity_Errors.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
            else if (errorJson.Uvsity_Errors_Stacktrace) {
                console.log("Uvsity Exception containing stacktrace");
                errorJson.Uvsity_Errors_Stacktrace.map(function (uvsityError) { _this.showErrorMessages.push(uvsityError); });
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
                this.isValidationError = false;
            }
            else {
                console.log("Not Uvsity Exception");
                this.showErrorMessages.push("An unexpected error occurred, Please try after sometime.");
                this.showErrorPopupWidthInPercentage = "100%";
                this.showErrorModalDialog = true;
            }
        }
        else {
            this.errorHandlerService.throwError(error);
        }
    };
    ResetPasswordComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
        //this.router.navigate(['/login']);
    };
    ResetPasswordComponent.prototype.closePopup = function () {
        this._closePopup.emit(true);
    };
    return ResetPasswordComponent;
}());
export { ResetPasswordComponent };
//# sourceMappingURL=resetPassword.component.js.map